import { createContext } from "react";

const globalContext = createContext<any>({})

export default globalContext